// Content for the downloadable stay quote (PDF), in the site's 3 languages.
export const QUOTE = {
  it: {
    docTitle: "Preventivo di soggiorno",
    subtitle: "B&B I Lake It Bellagio · Bellagio, Lago di Como",
    generatedOn: "Preventivo generato il",
    validity: "Preventivo indicativo, soggetto a disponibilità al momento della conferma.",
    summaryTitle: "Riepilogo del soggiorno",
    lblDates: "Date", lblNights: "Notti", lblGuests: "Ospiti", lblRoom: "Camera", lblRooms: "Camere",
    lblTotal: "Totale soggiorno · colazione inclusa",
    night: "notte", nights: "notti", guest: "ospite", guests: "ospiti",
    usefulTitle: "Informazioni utili",
    useful: [
      "Check-in dalle 16:00 · Check-out entro le 10:30.",
      "Colazione inclusa, servita dalle 8:30 alle 10:00.",
      "Self check-in: riceverà le istruzioni e i codici di accesso entro le ore 16:00 del giorno di arrivo.",
      "Parcheggio gratuito riservato nel cortile videosorvegliato.",
      "Cancellazione sempre gratuita fino al giorno del check-in. Le chiediamo cortesemente di comunicarci eventuali disdette con il maggior anticipo possibile.",
    ],
    servicesTitle: "Servizi della camera",
    taxNote: "* La tassa di soggiorno non è inclusa nel totale del soggiorno.\nL'importo è di €3 a notte per persona, con esenzione per i bambini fino a 10 anni.\nPagamento in contanti: la tassa di soggiorno sarà offerta dalla struttura e non verrà quindi addebitata all'ospite.\nPagamento con carta: la tassa di soggiorno verrà applicata regolarmente e aggiunta all'importo totale del soggiorno.",
    footer: "Grazie per aver scelto I Lake It Bellagio. Saremo felici di ospitarla.",
  },
  en: {
    docTitle: "Stay quote",
    subtitle: "B&B I Lake It Bellagio · Bellagio, Lake Como",
    generatedOn: "Quote generated on",
    validity: "Indicative quote, subject to availability at the time of confirmation.",
    summaryTitle: "Stay summary",
    lblDates: "Dates", lblNights: "Nights", lblGuests: "Guests", lblRoom: "Room", lblRooms: "Rooms",
    lblTotal: "Total stay · breakfast included",
    night: "night", nights: "nights", guest: "guest", guests: "guests",
    usefulTitle: "Useful information",
    useful: [
      "Check-in from 4:00 pm · Check-out by 10:30 am.",
      "Breakfast included, served from 8:30 to 10:00.",
      "Self check-in: you will receive the access instructions and codes by 4:00 pm on the day of arrival.",
      "Free reserved parking in the video-surveilled courtyard.",
      "Cancellation is always free up to the day of check-in. We kindly ask you to let us know of any cancellation as early as possible.",
    ],
    servicesTitle: "Room services",
    taxNote: "* The tourist tax is not included in the stay total.\nThe amount is €3 per night per person, with exemption for children up to 10 years old.\nCash payment: the tourist tax is offered by the property and will not be charged to the guest.\nCard payment: the tourist tax is applied as usual and added to the stay total.",
    footer: "Thank you for choosing I Lake It Bellagio. We look forward to hosting you.",
  },
  fr: {
    docTitle: "Devis de séjour",
    subtitle: "B&B I Lake It Bellagio · Bellagio, Lac de Côme",
    generatedOn: "Devis généré le",
    validity: "Devis indicatif, soumis à disponibilité au moment de la confirmation.",
    summaryTitle: "Récapitulatif du séjour",
    lblDates: "Dates", lblNights: "Nuits", lblGuests: "Voyageurs", lblRoom: "Chambre", lblRooms: "Chambres",
    lblTotal: "Total du séjour · petit-déjeuner inclus",
    night: "nuit", nights: "nuits", guest: "voyageur", guests: "voyageurs",
    usefulTitle: "Informations utiles",
    useful: [
      "Arrivée à partir de 16h00 · Départ avant 10h30.",
      "Petit-déjeuner inclus, servi de 8h30 à 10h00.",
      "Self check-in : vous recevrez les instructions et les codes d'accès avant 16h00 le jour de l'arrivée.",
      "Parking gratuit réservé dans la cour sous vidéosurveillance.",
      "Annulation toujours gratuite jusqu'au jour de l'arrivée. Nous vous prions de nous informer de toute annulation le plus tôt possible.",
    ],
    servicesTitle: "Services de la chambre",
    taxNote: "* La taxe de séjour n'est pas incluse dans le total du séjour.\nLe montant est de 3 € par nuit et par personne, avec exonération pour les enfants jusqu'à 10 ans.\nPaiement en espèces : la taxe de séjour est offerte par l'établissement et ne sera donc pas facturée à l'hôte.\nPaiement par carte : la taxe de séjour est appliquée normalement et ajoutée au total du séjour.",
    footer: "Merci d'avoir choisi I Lake It Bellagio. Nous serons ravis de vous accueillir.",
  },
};
